module.exports = __webpack_public_path__ + "img/dashboard-icon-active.9762849e.svg";